module.exports = __webpack_public_path__ + "static/media/wedigitek.4b879c77.png";